import type { EntityAccessInvitationsAction } from './entityAccessInvitations.action';
import {
  entityAccessSetDeleteReceivedInvitations, entityAccessSetReceivedInvitations,
} from './entityAccessInvitations.actionCreators';
import type { EntityAccessInvitationsState } from './entityAccessInvitations.state';

const initialState: EntityAccessInvitationsState = {
  receivedInvitations: [],
};

export const entityAccessInvitationsReducer = (state = initialState, action: EntityAccessInvitationsAction): EntityAccessInvitationsState => {
  if (entityAccessSetReceivedInvitations.match(action)) {
    return {
      ...state,
      receivedInvitations: action.payload.newInvitations,
    };
  }

  if (entityAccessSetDeleteReceivedInvitations.match(action)) {
    return {
      ...state,
      receivedInvitations: state.receivedInvitations.filter(
        invitation => !action.payload.ids.has(invitation.id)
      ),
    };
  }

  return state;
};
